import * as stylePresetType from 'constants/stylePresetType'


function serialiseHidden (paramName, value) {
  switch (paramName) {
    case 'value':
      return value ? 'display: none;' : ''
    default:
      return `${paramName}: ${value};`
  }
}

function serialisePosition (paramName, value, sizeKind) {
  switch (paramName) {
    case 'x':
      return `margin-left: ${isNaN(Number(value)) ? 0 : value}${sizeKind};\nmargin-right: ${isNaN(Number(value)) ? 0 : -value}${sizeKind};`
    case 'y':
      return `margin-top: ${isNaN(Number(value)) ? 0 : value}${sizeKind};\nmargin-bottom: ${isNaN(Number(value)) ? 0 : -value}${sizeKind};`
    default:
      return `${paramName}: ${value};`
  }
}

function serialiseTextEffect (paramName, value) {
  if (paramName === 'type') return null
  let res = ''
  for (const p of value) {
    res = res + `${p.paramName}: ${p.value}\n`
  }
  return res
}

function serialiseZoom (paramName, value) {
  switch (paramName) {
    case 'zoom':
      return `transform: scale(${value}); font-size: ${value}rem;`
    default:
      return `${paramName}: ${value};`
  }
}

function serialiseDarkenLighten (paramName, value) {
  switch (paramName) {
    case 'value':
      if (value > 0) {
        return `background-color: rgba(255, 255, 255, ${value});\nbackground-blend-mode: overlay;`
      } else if (value < 0) {
        return `background-color: rgba(0, 0, 0, ${Math.abs(value)});\nbackground-blend-mode: overlay;`
      } else {
        return null
      }
    default:
      return `${paramName}: ${value};`
  }
}

function serialiseAround (paramName, value) {
  switch (paramName) {
    case 'value':
      return `background-size: ${value}%;`
    case 'color':
      return `background-color: ${`rgba(${value.r}, ${value.g}, ${value.b}, ${value.a})`};`
    default:
      return `${paramName}: ${value};`
  }
}

function serialiseColor (paramName, value) {
  return `color: ${value};\nborder-color:${value};`
}

export function customCSSParamToString (effectName, paramName, value, sizeKind = 'rem') {
  switch (effectName) {
    case stylePresetType.HIDDEN:
      return serialiseHidden(paramName, value)

    case stylePresetType.POSITION:
      return serialisePosition(paramName, value, sizeKind)

    case stylePresetType.TEXT_EFFECT:
      return serialiseTextEffect(paramName, value)

    case stylePresetType.ZOOM:
      return serialiseZoom(paramName, value)

    case stylePresetType.DARKEN_LIGHTEN:
      return serialiseDarkenLighten(paramName, value)

    case stylePresetType.AROUND:
      return serialiseAround(paramName, value)

    case stylePresetType.COLOR:
      return serialiseColor(paramName, value)

    default:
      return `${paramName}: ${value};`
  }
}

// used in the editor UI, uses `em` instead `rem`
export function customCSSEffectToStringSimple (effects) {
  let res = ''
  for (const effectName in effects) {
    const effect = effects[effectName]
    for (const paramName in effect) {
      const value = effect[paramName]
      const str = customCSSParamToString(effectName, paramName, value, 'em')
      if (str !== null) res = res.concat(`${str} \n`)
    }
  }
  return res
}

export function customCSSObjectToString (styles) {
  let res = ''
  for (const className in styles) {
    res = res.concat(`.${className} {\n`)
    const effects = styles[className]
    for (const effectName in effects) {
      const effect = effects[effectName]
      for (const paramName in effect) {
        const value = effect[paramName]
        const str = customCSSParamToString(effectName, paramName, value, 'rem')
        if (str !== null) res = res.concat(`${str} \n`)
      }
    }
    res = res.concat('}\n')
  }
  // console.log('res', res)
  return res
}



// WEBPACK FOOTER //
// ./src/utils/serializerCSS.js